import React from "react";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThumbsDown as solidThumbsDown, faThumbsUp as solidThumbsUp} from "@fortawesome/free-solid-svg-icons";
import {faThumbsDown as regularThumbsDown, faThumbsUp as regularThumbsUp} from "@fortawesome/free-regular-svg-icons";
import {useTranslation} from "react-i18next";
import {IExtractImageModel} from "../../types/manualFinder";
import {OverlayTooltip} from "../../components";

interface IFeedbackButtonsProps {
    onClickFeedback: (isUseful: boolean, id: any) => Promise<void>
    imageSet: IExtractImageModel
}

export const FeedbackButtons: React.FC<IFeedbackButtonsProps> = ({onClickFeedback, imageSet}) => {
    const {t} = useTranslation();

    return (
        <div className="d-flex justify-content-center align-items-center pb-3 gap-2">
            <OverlayTooltip tooltipContent={t("ExtractedImages.FeebackToolTipText")}/>
            <Button
                className="text-align-center d-flex align-items-center justify-content-center"
                variant="secondary"
                onClick={() => onClickFeedback(true, imageSet.parentFile.id)}
            >
                <FontAwesomeIcon
                    icon={
                        imageSet.isUseful === true
                            ? solidThumbsUp
                            : regularThumbsUp
                    }
                    size="lg"
                />
            </Button>
            <Button
                className="text-align-center d-flex align-items-center justify-content-center"
                variant="secondary"
                onClick={() =>
                    onClickFeedback(false, imageSet.parentFile.id)
                }
            >
                <FontAwesomeIcon
                    icon={
                        imageSet.isUseful === false
                            ? solidThumbsDown
                            : regularThumbsDown
                    }
                    size="lg"
                />
            </Button>
        </div>
    );
};
